import NonLoginShoppingCartButton from '~/components/NonLogin/NonLoginShoppingCartButton';
import { VENDORS_ROUTER } from '~/constants/router';
import { useCurrentUser } from '~/domains/auth/queries';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import DeliveryFlag from '~/domains/delivery/DeliveryFlag';
import ProductPrice from '~/domains/products/components/ProductPrice';
import ProductSalesTargetBadge from '~/domains/products/components/ProductSalesTargetBadge';
import ProductImage from '~/domains/products/ProductImage';
import { useAdultGuardClick, useShowAdultBadge } from '~/domains/products/useShowAdultBadge';
import { useTrackProductEventProps } from '~/hooks/event';
import { useLinkComponent } from '~/hooks/mobileApp';
import type { OAISchema } from '~/types/openapi';

type Props = {
  inverse?: boolean;
  onClick?: (item: OAISchema['MarketSelectProductResponseV2']) => void;
  onCartClick?: (item: OAISchema['MarketSelectProductResponseV2']) => void; // TODO - 앰플리튜드 이벤트 한번 싹 정리할 떄, 제거 함.
  eventOption?: Record<string, unknown>;
  plusMembershipFullBadge?: boolean;
  reverseCouponDiscountedPrice?: boolean;
} & OAISchema['MarketSelectProductResponseV2'];

const RecentlyViewedProductCard = ({
  onClick,
  onCartClick,
  eventOption,
  plusMembershipFullBadge = false,
  reverseCouponDiscountedPrice = false,
  ...data
}: Props) => {
  const { isLoggedIn } = useCurrentUser();
  const LinkComponent = useLinkComponent();
  const {
    offerId,
    vendorId,
    mainImages,
    productName,
    isOutOfStock,
    status,
    inverse,
    mallName,
    salesTargets,
    deliveryFlags,
  } = data;
  const [props, { trackAddCart }] = useTrackProductEventProps(
    data,
    eventOption,
  );
  const showAdultBadge = useShowAdultBadge(data.adultOnly);
  const guardAdultClick = useAdultGuardClick(data.adultOnly);

  return (
    <LinkComponent href={VENDORS_ROUTER.productDetail(vendorId, offerId!)}>
      <div
        role="presentation"
        {...props}
        onClick={(e) => {
          if (guardAdultClick(e)) return;
          props.onClick?.();
        }}
      >
        {mainImages![0] && (
          <ProductImage
            width={100}
            height={100}
            sizes="45vw"
            layout="responsive"
            src={mainImages![0]}
            alt={productName}
            showAdultBadge={showAdultBadge}
            isOutOfStock={isOutOfStock}
            status={status}
            inverse={inverse}
            rightBottom={
              isLoggedIn ? (
                <ShoppingCartButton
                  className="mb-6 mr-8"
                  onClick={() => {
                    onClick?.(data);
                    trackAddCart?.();
                    onCartClick?.(data);
                  }}
                  item={data}
                />
              ) : (
                <NonLoginShoppingCartButton />
              )
            }
          />
        )}
        <ProductSalesTargetBadge
          salesTargets={salesTargets}
          className="mb-4"
          full={plusMembershipFullBadge}
        />
        <div className="mb-4 text-hint typo-footnote300-regular">
          {mallName}
        </div>
        <div
          className="mb-4 line-clamp-2 whitespace-pre-line leading-[18px] text-normal"
          style={{ fontSize: '14px' }}
        >
          {productName}
        </div>
        <ProductPrice {...data} reverse={reverseCouponDiscountedPrice} />
        <DeliveryFlag flags={deliveryFlags} />
      </div>
    </LinkComponent>
  );
};

export default RecentlyViewedProductCard;
